// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3XuQN","notes":"Notes_notes__268FX"};